import React from "react";
import { Person, Schedule, CalendarMonth } from "@mui/icons-material";
import { Box, Typography, Card, Grid, CardContent } from "@mui/material";
import dayjs from "dayjs";
import { themes } from "services/constants";

export default function ShiftGradePreview({
  shiftName,
  weekoffValue,
  shiftDuration,
  IsViewScreen,
}) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={6}>
        <Card
          sx={{
            bgcolor: themes?.babyBlue,
            border: `1px solid ${themes?.lightBlue}`,
            height: "100%",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mb: 1,
              }}
            >
              <Box
                sx={{
                  bgcolor: "primary.main",
                  p: 1,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Person sx={{ color: "white", fontSize: 20 }} />
              </Box>
              <Typography variant="subtitle1" fontWeight="500">
                Name
              </Typography>
            </Box>
            <Typography
              variant="body1"
              fontWeight="600"
              color="primary.dark"
              sx={{ wordBreak: "break-word", fontSize: "17px" }}
            >
              {shiftName || "-"}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <Card
          sx={{
            bgcolor: themes?.palegreen,
            border: `1px solid ${themes?.freshgreen}`,
            height: "100%",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mb: 1,
              }}
            >
              <Box
                sx={{
                  bgcolor: "success.main",
                  p: 1,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Schedule sx={{ color: "white", fontSize: 20 }} />
              </Box>
              <Typography variant="subtitle1" fontWeight="500">
                Shift Hours
              </Typography>
            </Box>
            <Typography variant="h6" fontWeight="600" color="success.dark">
              {IsViewScreen
                ? shiftDuration
                : shiftDuration
                ? dayjs(shiftDuration).format("HH:mm")
                : "00:00"}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={12}>
        <Card
          sx={{
            bgcolor: themes?.palepink,
            border: `1px solid ${themes?.pinkishred}`,
            height: "100%",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mb: 1,
              }}
            >
              <Box
                sx={{
                  bgcolor: "error.main",
                  p: 1,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CalendarMonth sx={{ color: "white", fontSize: 20 }} />
              </Box>
              <Typography variant="subtitle1" fontWeight="500">
                Weekoff
              </Typography>
            </Box>
            <Typography
              variant="body1"
              fontWeight="600"
              color="error.dark"
              sx={{
                whiteSpace: "pre-line",
                wordBreak: "break-word",
                fontSize: "17px",
              }}
            >
              {weekoffValue ? weekoffValue : "-"}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
